import React from 'react';

import { PermissionLinkProps } from './PermissionLink.props';
import { isUserHasPermission } from '../../../configs/permissions';
import { useGetUserSystemPermissions } from '../../../queries/user-query';
import { Link } from '../Link';

/**
 * A link that only renders as clickable when the current user has the
 * required permission. Otherwise renders children as plain text.
 *
 * This prevents restricted users (clients, partners) from seeing
 * clickable links that lead to 404s or permission errors.
 */
export const PermissionLink: React.FC<PermissionLinkProps> = ({
  permission,
  href,
  children,
  color,
  sx,
  target,
}) => {
  const { data: permissions } = useGetUserSystemPermissions();

  if (permission && isUserHasPermission(permission, permissions)) {
    return (
      <Link href={href} color={color} sx={sx} target={target}>
        {children}
      </Link>
    );
  }

  return <>{children}</>;
};
